import React, { memo, useContext } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Breadcrumbs from 'components/common/Breadcrumbs';
import { HeaderContext } from 'components/HeaderContext';
import logo from 'images/logo.png';
import './BrandBar.scss';
const BrandBar = ({ location: { pathname } }) => {
    var _a;
    return (React.createElement("div", { className: "BrandBar" },
        React.createElement(Breadcrumbs, null),
        React.createElement("div", { className: "BrandBar__ctx" }, (_a = useContext(HeaderContext)) === null || _a === void 0 ? void 0 : _a.getUrlComponent(pathname)),
        React.createElement(Link, { className: "BrandBar__link", to: "/landing-page" },
            React.createElement("img", { className: "BrandBar__logo", src: logo, alt: "" }))));
};
export default memo(withRouter(BrandBar));
